import router from 'next/router'
import { useEffect, useRef, useState, VFC } from 'react'
import { SearchIcon } from 'src/assets/svgs'
import { MatchingStatusType, RoomStatusType } from 'src/models/Room'
import { _menuicon, _searchbg } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { convertMessagePageQuqry, toMessagePageQuery } from 'src/utils/routes'
import styled from 'styled-components'
import { Filter } from './Filter'

const FIVE_HUNDRED_MILLISECONDS = 500
const sleepFor500ms = () =>
  new Promise((resolve) => setTimeout(resolve, FIVE_HUNDRED_MILLISECONDS))

type SearchbarProps = {
  activeRoomName: string
  setLoading: (loading: boolean) => void
  activeMatchingStatus: MatchingStatusType
  activeRoomStatus: RoomStatusType
}
export const Searchbar: VFC<SearchbarProps> = ({
  activeRoomName,
  setLoading,
  activeMatchingStatus,
  activeRoomStatus,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const [roomName, setRoomName] = useState<string>(activeRoomName)

  // NOTE: 画面描画時や更新時に query の値をセットする
  useEffect(() => {
    setRoomName(activeRoomName)
  }, [activeRoomName])

  // NOTE: onChange 後の 0.5秒後に input.value が変更されていなければ検索します
  const searchByKeyword = async () => {
    setLoading(true)
    const beforeValue = inputRef.current?.value
    await sleepFor500ms()

    const currentValue = inputRef.current?.value
    if (beforeValue === currentValue) {
      const query = convertMessagePageQuqry(router.query)
      router.push(
        toMessagePageQuery({
          pathname: router.pathname,
          query: {
            ...query,
            room_name: currentValue,
          },
        }),
      )
    }
    setLoading(false)
  }
  return (
    <>
      <Area>
        <StyledSearchIcon />
        <Input
          ref={inputRef}
          value={roomName}
          placeholder="企業名または決裁者名を入力"
          onChange={({ target: { value } }) => {
            setRoomName(value)
            searchByKeyword()
          }}
        />
      </Area>
      <Filter
        activeMatchingStatus={activeMatchingStatus}
        activeRoomStatus={activeRoomStatus}
      />
    </>
  )
}

const Area = styled.div`
  margin: 8px 0px;
  position: relative;
`
const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  padding-left: 8px;
  margin: 4px 0px 8px 8px;
`
const Input = styled.input`
  background-color: ${_searchbg};
  border-radius: 20px;
  ::placeholder {
    color: ${_menuicon};
    font-size: 14px;
    font-weight: ${fontWeightBold};
  }
  width: 100%;
  padding: 8px 0px 8px 40px;
`
